import PropTypes from "prop-types";
import { useState } from "react";
import AnnouncementCard from "../components/announcement/announcementCard";

const Announcements = ({ announcements }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    // Calculate total pages
    const totalPages = Math.ceil(announcements?.length / itemsPerPage);

    // Get current items for the page
    const currentAnnouncements = announcements?.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handle page change
    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    return (
        <div className="flex items-center justify-center w-full p-8">
            <div className="flex items-center justify-center lg:max-w-7xl w-full">
                {announcements?.length > 0 ? (
                    <div className="flex flex-col gap-5 w-full">
                        {currentAnnouncements?.map((announcement, index) => (
                            <AnnouncementCard key={index} {...announcement} />
                        ))}

                        {/* Pagination Controls */}
                        <div className="flex justify-center mt-4">
                            <button
                                className={`px-4 py-2 mx-1 ${currentPage === 1 ? "opacity-50 cursor-not-allowed" : ""}`}
                                onClick={() => handlePageChange(currentPage - 1)}
                                disabled={currentPage === 1}
                            >
                                Previous
                            </button>

                            {[...Array(totalPages)].map((_, i) => (
                                <button
                                    key={i}
                                    className={`px-4 py-2 mx-1 transition-all rounded-lg ${currentPage === i + 1 ? "font-bold bg-blue-400 text-white" : ""}`}
                                    onClick={() => handlePageChange(i + 1)}
                                >
                                    {i + 1}
                                </button>
                            ))}

                            <button
                                className={`px-4 py-2 mx-1 ${currentPage === totalPages ? "opacity-50 cursor-not-allowed" : ""}`}
                                onClick={() => handlePageChange(currentPage + 1)}
                                disabled={currentPage === totalPages}
                            >
                                Next
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className="flex justify-center items-center w-full h-96">
                        <span className="text-2xl text-center font-semibold text-gray-400">No Data Found</span>
                    </div>
                )}
            </div>
        </div>
    );
};

Announcements.propTypes = {
    announcements: PropTypes.array.isRequired,
};

export default Announcements;
